import { v4 as uuidv4 } from 'uuid';

const alignement = [
    {
        idSoft: uuidv4(),
        name: 'Center',
        value: 'center',
        alignement: 'center',
    },
    {
        idSoft: uuidv4(),
        name: 'Haut',
        value: 'top',
        alignement: 'flex-start',
    },
    {
        idSoft: uuidv4(),
        name: 'Bas',
        value: 'bottom',
        alignement: 'flex-end',
    }
];

export default alignement;
